import {
  DV_360_PLATFORM,
  FACEBOOK_PLATFORM,
  GOOGLE_AD_MANAGER_PLATFORM,
  GOOGLE_PLATFORM,
  TIKTOK_PLATFORM
} from '../constants/selectLists/platformList'

const formatAdAccountData = adAccountData => ({
  ...adAccountData,
  // it is used selectedAdAccount.id across all app
  // instead adAccount from BE have set id in external_id field, so id should be reset to external_id here:
  id: adAccountData.external_id
})

export function getAdAccountsData(selectedPartnership = {}) {
  const {
    facebook_ad_account: facebookAdAccount,
    google_ad_account: googleAdAccount,
    dv360_ad_account: dv360AdAccount,
    tiktok_ad_account: tikTokAdAccount,
    gam_ad_account: gamAdAccount
  } = selectedPartnership

  // adAccounts data is placed on partnership level
  return {
    [FACEBOOK_PLATFORM]: facebookAdAccount ? formatAdAccountData(facebookAdAccount) : {},
    [GOOGLE_PLATFORM]: googleAdAccount ? formatAdAccountData(googleAdAccount) : {},
    [DV_360_PLATFORM]: dv360AdAccount ? formatAdAccountData(dv360AdAccount) : {},
    [TIKTOK_PLATFORM]: tikTokAdAccount ? formatAdAccountData(tikTokAdAccount) : {},
    [GOOGLE_AD_MANAGER_PLATFORM]: gamAdAccount ? formatAdAccountData(gamAdAccount) : {}
  }
}
